import { useEffect, useState } from 'react';
import {
  performanceApi,
  type PerformanceTimeseriesResponse,
  ApiError,
} from '@/services/api';
import { usePerformanceContext } from '../../PerformanceContext';

interface State {
  data: PerformanceTimeseriesResponse | null;
  loading: boolean;
  error: string | null;
}

export function useCampaignTimeseries(campaignId: string | undefined) {
  const { clientUid, dateFrom, dateTo } = usePerformanceContext();
  const [state, setState] = useState<State>({ data: null, loading: false, error: null });

  useEffect(() => {
    if (!clientUid || !campaignId || !dateFrom || !dateTo) return;
    let cancelled = false;
    setState((s) => ({ ...s, loading: true, error: null }));

    performanceApi
      .getCampaignTimeseries(campaignId, { clientUid, dateFrom, dateTo })
      .then((data) => {
        if (cancelled) return;
        setState({ data, loading: false, error: null });
      })
      .catch((err) => {
        if (cancelled) return;
        const msg = err instanceof ApiError ? err.body : String(err);
        setState({ data: null, loading: false, error: msg });
      });

    return () => {
      cancelled = true;
    };
  }, [clientUid, campaignId, dateFrom, dateTo]);

  return state;
}
